module.exports = __webpack_public_path__ + "img/182-9c6df8.png";